module.exports = __webpack_public_path__ + "img/icon-premio.8231e709.png";